<template>
  <div class="print-account-receipt-container">
    <!-- 标题区：图标+小区名整体居中 -->
    <div class="header-area">
      <h1 class="title-text"><span class="logo-icon">◎</span>{{printAccountReceiptInfo.communityName}}预存收款单据</h1>
    </div>

    <!-- NO编号在标题下方，靠右 -->
    <div class="receipt-info-bar">
      <div class="receipt-no">NO. {{printAccountReceiptInfo.receiptNum}}</div>
    </div>

    <!-- 基本信息 + 结算方式同一行 -->
    <div class="info-bar">
      <span>日期：<i>{{dateFormatShort(printAccountReceiptInfo.feeTime)}}</i></span>
      <span class="customer-name-inline">客户名称：<i>{{printAccountReceiptInfo.ownerName}}</i></span>
      <span class="pay-method-right">结算方式：<i>{{printAccountReceiptInfo.payMethod || '现金'}}</i></span>
    </div>

    <!-- 明细表格 -->
    <table class="receipt-table">
      <thead>
        <tr>
          <th class="col-item">开具项目</th>
          <th class="col-qty">数量/面积</th>
          <th class="col-price">单价</th>
          <th class="col-money">金额</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in printAccountReceiptInfo.feeReceipts" :key="index">
          <td class="col-item td-left">{{item.acctName}}（{{item.acctTypeName}}）</td>
          <td class="col-qty td-center"></td>
          <td class="col-price td-center"></td>
          <td class="col-money td-right">{{parseFloat(item.receivedAmount).toFixed(2)}}</td>
        </tr>
        <tr class="row-total">
          <td colspan="3" class="td-left total-label">合计（大写金额）：<b>{{changeNumMoneyToChinese(printAccountReceiptInfo.amount)}}</b></td>
          <td class="td-right total-num"><b>¥:{{printAccountReceiptInfo.amount}}</b></td>
        </tr>
        <tr class="row-remark" v-if="printAccountReceiptInfo.content || printAccountReceiptInfo.qrImg">
          <td colspan="4" class="td-left remark-content">
            <div v-if="printAccountReceiptInfo.content" v-html="printAccountReceiptInfo.content" style="float:left;max-width:70%"></div>
            <img v-if="printAccountReceiptInfo.qrImg" :src="printAccountReceiptInfo.qrImg" width="80px" height="80px" style="float:right">
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 底部区域（表格外） -->
    <div class="footer-outside">
      <span class="footer-note-left">凭此收款收据十日内到服务中心换取电子发票</span>
      <span class="footer-payee-right">收款人：{{userInfo.name}}</span>
    </div>

    <!-- 操作按钮（打印时隐藏） -->
    <div id="print-btn" class="action-buttons">
      <el-button type="primary" size="small" @click="handlePrint">
        <i class="el-icon-printer"></i>&nbsp;打印
      </el-button>
      <el-button type="warning" size="small" style="margin-right:10px;" @click="handleCancel">
        取消
      </el-button>
    </div>
  </div>
</template>

<script>
import { listAccountReceipt, queryFeePrintSpec } from '@/api/account/printAccountReceiptApi'
import { getUserId, getUserName } from '@/api/user/userApi'
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'

export default {
  name: 'PrintAccountReceiptList',
  data() {
    return {
      printAccountReceiptInfo: {
        communityName: '',
        arIds: '',
        amount: 0.00,
        feeReceipts: [],
        content: '',
        qrImg: '',
        receiptNum: '',
        feeTime: '',
        ownerName: '',
        payMethod: ''
      },
      printFlag: '0',
      userInfo: {}
    }
  },
  created() {
    this.printAccountReceiptInfo.arIds = this.$route.query.arIds
    this.printAccountReceiptInfo.communityName = getCommunityName()
    this.userInfo = {
      userId: getUserId(),
      name: getUserName()
    }
    this.initData()
  },
  methods: {
    async initData() {
      await this.loadReceipt()
      this.loadPrintSpec()
    },
    async loadReceipt() {
      try {
        const params = {
          page: 1,
          row: 30,
          arIds: this.printAccountReceiptInfo.arIds,
          communityId: getCommunityId()
        }

        const { data } = await listAccountReceipt(params)
        let amount = 0
        data.forEach(item => {
          amount += parseFloat(item.receivedAmount)
        })
        this.printAccountReceiptInfo.amount = amount.toFixed(2)
        this.printAccountReceiptInfo.feeReceipts = data
        if (data && data.length > 0) {
          this.printAccountReceiptInfo.receiptNum = data[0].arId
          this.printAccountReceiptInfo.feeTime = data[0].createTime
          this.printAccountReceiptInfo.ownerName = data[0].ownerName || ''
          this.printAccountReceiptInfo.payMethod = data[0].primeRateName || ''
        }
      } catch (error) {
        this.$message.error('加载收据数据失败')
      }
    },
    async loadPrintSpec() {
      try {
        const params = {
          page: 1,
          row: 1,
          specCd: 2020,
          communityId: getCommunityId()
        }

        const { data } = await queryFeePrintSpec(params)
        if (data.length > 0) {
          this.printAccountReceiptInfo.content = data[0].content
          this.printAccountReceiptInfo.qrImg = data[0].qrImg
          if (data[0].printName) {
            this.printAccountReceiptInfo.communityName = data[0].printName
          }
        }
      } catch (error) {
        // 打印规格加载失败不影响主流程
      }
    },
    dateFormatShort(date) {
      if (!date) return ''
      const d = new Date(date)
      if (isNaN(d.getTime())) return date
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return y + '-' + m + '-' + dd
    },
    changeNumMoneyToChinese,
    handlePrint() {
      this.printFlag = '1'
      document.getElementById("print-btn").style.display = "none"
      window.print()
      window.close()
    },
    handleCancel() {
      window.close()
    }
  }
}
</script>

<style scoped>
/* ===== 屏幕预览 - 与缴费收据一致 ===== */
.print-account-receipt-container {
  width: 220mm;
  margin: 0 auto;
  padding: 3mm 5mm;
  background: #fff;
  font-family: '黑体', SimHei, 'Microsoft YaHei', sans-serif;
  font-size: 14px;
  color: #000;
}

/* 标题区：图标+小区名整体居中 */
.header-area {
  text-align: center;
  padding: 0.5mm 0 0 0;
}

.logo-icon {
  font-size: 22px;
  font-weight: bold;
  margin-right: 4px;
  vertical-align: middle;
}

.title-text {
  display: inline-block;
  font-size: 22px;
  font-weight: bold;
  margin: 0;
  letter-spacing: 3px;
  white-space: nowrap;
}

/* NO编号：标题下方，靠右 */
.receipt-info-bar {
  text-align: right;
  padding: 0.5mm 0 1mm 0;
}

.receipt-no {
  font-family: 'Courier New', monospace;
  font-size: 14px;
}

/* 基本信息栏：日期 + 客户名称 + 结算方式同一行 */
.info-bar {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 1mm 0;
  font-size: 14px;
}

.info-bar i {
  font-style: normal;
}

.customer-name-inline {
  flex: 1;
}

.pay-method-right {
  white-space: nowrap;
  font-size: 13px;
  flex-shrink: 0;
}

/* 明细表格 - 有边框 */
.receipt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.receipt-table th,
.receipt-table td {
  border: 1px solid #000;
  padding: 1mm 3px;
  vertical-align: middle;
  line-height: 1.3;
}

.receipt-table thead th {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}

.col-item { width: 58%; }
.col-qty { width: 12%; }
.col-price { width: 12%; }
.col-money { width: 18%; font-weight: bold; }

.td-left { text-align: left; }
.td-center { text-align: center; }
.td-right { text-align: right; }

.row-total td,
.row-remark td {
  font-size: 12.5px;
}

.total-label b,
.total-num b {
  font-weight: bold;
}

.remark-content {
  min-height: 4mm;
  font-size: 12px;
  overflow: hidden;
}

/* 底部区域（表格外） */
.footer-outside {
  margin-top: 2mm;
  font-size: 12.5px;
  overflow: hidden;
}

.footer-note-left {
  float: left;
}

.footer-payee-right {
  float: right;
}

/* 操作按钮 */
.action-buttons {
  margin-top: 20px;
  text-align: center;
  padding: 10px 0;
}

/* ===== 打印样式 ===== */
@media print {
  @page {
    size: 241mm auto;
    margin: 5mm 5mm 5mm 0;
  }

  body { margin: 0; padding: 0; }

  .print-account-receipt-container {
    width: 100%;
    margin: 0 0 0 -15mm;
    padding: 0;
    font-family: '黑体', SimHei, 'Microsoft YaHei', sans-serif;
    font-size: 11pt;
  }

  .title-text { font-size: 17pt; }
  .receipt-info-bar { font-size: 10pt; }
  .receipt-no { font-size: 11pt; font-family: '黑体', SimHei, 'Microsoft YaHei', sans-serif; }
  .info-bar { font-size: 10.5pt; }
  .pay-method-right { font-size: 9.5pt; }
  .receipt-table { font-size: 10.5pt; }
  .receipt-table thead th { font-size: 11pt; }
  .row-total td, .row-remark td { font-size: 10pt; }
  .footer-outside { font-size: 9.5pt; }
  .remark-content { font-size: 9.5pt; }

  #print-btn { display: none !important; }
  .action-buttons { display: none !important; }
}
</style>

<!-- 全局（非 scoped）：打印时清除外层 body/#app 的默认边距 -->
<style>
@media print {
  html,
  body,
  #app,
  #app > div {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
